import React ,{useState,useEffect}from 'react'
import {Container,Table} from "react-bootstrap"
import QTable from '../../utilities/tableQuestionnaire/questionnaire';
import Questions_Table from '../../utilities/tableQuestionnaire/questionnaire_custom_answers'
import questions from './data.json'
// function Sas(props){
//     const [sas,setSas] = useState({})
//     const questions = [
//         "Are you interested in learning new things?",
//         "Does anything interest you?",
//         "Are you concerned about your condition?",
//         "Do you put much effort into things?",
//         "Are you always looking for something to do?",
//         "Do you have plans and goals for the future?",
//         "Do you have motivation?",
//         "Do you have the energy for daily activities?",
//         "Does someone have to tell you what to do each day?",
//         "Are you indifferent to things?",
//         "Are you unconcerned with many things?",
//         "Do you need a push to get started on things?",
//         "Are you neither happy nor sad, just in between?",
//         "Would you consider yourself apathetic?"
//     ]
    
//     const onChange = (event) =>{
//         props.handler('sas',event)
//     }

//     const answers = ['','not at all','slightly','some','a lot']
//     return (

//         <QTable title= 'Starkstein Apathy Scale' questions={questions} answers={answers} handler={onChange} fieldName={'sas'}/>
//     )
// }

class Sas extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            score:0
        }       
       
      
    }
    Scoring = async (val)=> {
       
        
        if (!isNaN(val)){
             await this.setState((prevState) => 
                         ({
                             ...prevState,
                             score:prevState.score + (val)
 
                         })
                         
             )
         }
         
     }
    onChange = async (event) =>{
        const {name,value} = event.target
       await this.setState((prevState)=>({
            ...prevState,
            [name]:value
        }))
        this.props.handler('sas',this.state )
       
    }
    // answers = ['','not at all','slightly','some','a lot']
    // questions = [
    //     "Are you interested in learning new things?",
    //     "Does anything interest you?",
    //     "Are you concerned about your condition?",
    //     "Do you put much effort into things?",
    //     "Are you always looking for something to do?",
    //     "Do you have plans and goals for the future?",
    //     "Do you have motivation?",
    //     "Do you have the energy for daily activities?",
    //     "Does someone have to tell you what to do each day?",
    //     "Are you indifferent to things?",
    //     "Are you unconcerned with many things?",
    //     "Do you need a push to get started on things?",
    //     "Are you neither happy nor sad, just in between?",
    //     "Would you consider yourself apathetic?"
    // ]
   
    componentDidMount(){
        if(this.props.data!= null){
            this.setState(this.props.data)
        }
    }
    // componentDidUpdate(prevProps,prevState){
    //     if (prevState != this.state ){
    //         this.props.handler('sas',this.state )
    //     }
    // }
    render(){
       
        return(
            <Container>
                {/* <QTable title= 'Starkstein Apathy Scale' questions={this.questions} data={this.props.data} disabled={this.props.disabled} answers={this.answers} handler={this.onChange} fieldName={'sas'}/> */}
                <Questions_Table title= 'fab' score={true} scoreFunc={this.Scoring} questions={questions} data={this.props.data} disabled={this.props.disabled} answers={questions} handler={this.onChange} fieldName={'fab'}/>
                <Table>
                    <thead>
                        <tr>
                            <th>Score:</th>
                            <th><p className={'score'}>{this.state.score}</p></th>
                        </tr>
                    </thead>
                </Table>
            </Container>
        )
    }
    
   

}
Sas.defaultProps = {
    data:null,
    disabled:false
}

export default Sas;